import GradientBgMobile from "@/assets/svg/vvv/diagonal-gradient-mobile.svg";
import GradientBg from "@/assets/svg/vvv/diagonal-gradient.svg";
import VVVCTA from "@/components/vvv/CTA";
import Distribution from "@/components/vvv/Distribution";
import VVVFooter from "@/components/vvv/Footer";
import ForCreators from "@/components/vvv/ForCreators";
import Header from "@/components/vvv/Header";
import HowItWorks from "@/components/vvv/HowItWorks";
import VVVTestimonials from "@/components/vvv/Testimonials";
import VeryViralVideos from "@/components/vvv/VeryViralVideos";
import WhatWeDo from "@/components/vvv/WhatWeDo";
import { useEffect } from "react";

export default function VVV() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="bg-[#141414]">
      <Header />
      <WhatWeDo />
      <ForCreators />

      <div className="relative py-40 overflow-hidden">
        <img
          src={GradientBg}
          className="absolute max-w-[1650px] 4xl:max-w-[1850px] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 z-0 hidden lg:block"
          alt="Gradient Background"
        />
        <img
          src={GradientBgMobile}
          className="absolute w-full h-full inset-0 left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 z-0 lg:hidden"
          alt="Gradient Background"
        />
        <VeryViralVideos />
      </div>

      <HowItWorks />
      <Distribution />
      <VVVTestimonials />
      <VVVCTA />
      <VVVFooter />
    </div>
  );
}
